import { useQuery } from 'react-query';
import { getMSGraphScopeAndEndPoint } from '../shared/utils';
import { MSGraphScopes } from '../shared/constants';
import { useAuth } from '@iamexperiences/feature-auth';
import { getTenantBrandingLogoUrl } from '../redux/modules/graphApis';
import { OrgId } from '@microsoft/portal-app/lib/Organization/models/IOrganization';
import i18next from 'i18next';

export interface ITenantLogoURL {
  readonly bannerLogoRelativeUrl?: string;
  readonly cdnList?: string[];
  readonly id: string;
}

//Remove after migration
export interface ITenantLogoInfo {
  readonly bannerLogoUrl?: string;
}

export const useTenantBranding = (tenantId: OrgId) => {
  const { auth } = useAuth();
  return useQuery('bannerLogoUrl', async () => {
    let tenantBrandingUrl = '';
    // Ms Graph api implementation for getting Tenant Branding URL
    const { scope } = getMSGraphScopeAndEndPoint(MSGraphScopes.UserReadAll);
    const token = await auth.acquireToken({ scopes: [scope] });

    const response = await fetch(getTenantBrandingLogoUrl(tenantId), { headers: { Authorization: `Bearer ${token}` } });

    if (response.ok) {
      const currLang = i18next.language;
      const logoInfos: ITenantLogoURL[] = (await response.json()).value;
      const currentLogo = logoInfos.find(
        (logoInfo) =>
          logoInfo.id == currLang &&
          logoInfo.bannerLogoRelativeUrl &&
          logoInfo.bannerLogoRelativeUrl !== '' &&
          logoInfo.cdnList &&
          logoInfo.cdnList.length > 0,
      );
      if (currentLogo && currentLogo.cdnList) {
        tenantBrandingUrl = `https://${currentLogo.cdnList[0]}/${currentLogo.bannerLogoRelativeUrl}`;
      } else if (
        logoInfos.length > 0 &&
        logoInfos[0].bannerLogoRelativeUrl &&
        logoInfos[0].bannerLogoRelativeUrl !== '' &&
        logoInfos[0].cdnList &&
        logoInfos[0].cdnList.length > 0
      ) {
        tenantBrandingUrl = `https://${logoInfos[0].cdnList[0]}/${logoInfos[0].bannerLogoRelativeUrl}`;
      }
    }

    return tenantBrandingUrl;
  });
};
